import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Preloader from 'components/Preloader';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Button = ({
	title,
	icon,
	width,
	disabled,
	onClick,
	className,
	isLoading
}) => {
	const cxButton = cx(
		styles.Button,
		className,
		disabled && styles.Button_disabled,
		{
			[styles[`Button_${width}`]]: width
		}
	);
	const cxIcon = cx([styles[`Button__Icon_${icon}`]]);

	return (
		<button type="button" className={cxButton} onClick={onClick}>
			{isLoading ? (
				<Preloader iconSize="small" />
			) : (
				<>
					{icon ? <Icon icon={icon} className={cxIcon} /> : null}
					{title || null}
				</>
			)}
		</button>
	);
};

Button.propTypes = {
	title: PropTypes.string,
	icon: PropTypes.string,
	onClick: PropTypes.func,
	width: PropTypes.oneOf(['full', 'limited', 'square']),
	disabled: PropTypes.bool,
	className: PropTypes.string,
	isLoading: PropTypes.bool
};

export default Button;
